export const ALPHABET = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z']

export const EDITOR_CONFIG_BUTTONS_LITE = [
  'bold', 'italic', 'underline',
  {script: 'super'}, {script: 'sub'},
  {list: 'ordered'}, {list: 'bullet'}, 'clean'
]

export const EDITOR_CONFIG_LITE = {
  modules: {
    toolbar: EDITOR_CONFIG_BUTTONS_LITE
  }
}

export const EDITOR_CONFIG_BUTTONS_FULL = [
  ['bold', 'italic', 'underline', 'strike'],
  ['clean'],
  [{color: []}, {background: []}],
  [{script: 'super'}, {script: 'sub'}],
  [{header: '1'}, {header: '2'}, 'blockquote'],
  [{list: 'ordered'}, {list: 'bullet'}],
  [{indent: '-1'}, {indent: '+1'}],
  ['link', 'image', 'video'],
]

export const EDITOR_CONFIG_FULL = {
  modules: {
    toolbar: EDITOR_CONFIG_BUTTONS_FULL
  }
}

export const LMS_KEY_MAP = {
  'scorm': {
    '1.2': {
      'lesson_status': 'cmi.core.lesson_status',
      'lesson_status_completed_value': 'completed',
      'lesson_location': 'cmi.core.lesson_location',
      'score': 'cmi.core.score.raw'
    }
  }
}
